<template>
    <div class="d-flex flex-column">
        <div class="d-flex flex-column">
            <v-row no-gutters>
                <v-col cols="4">
                    <div>Scelta bilancia di confronto</div>
                    <div class="caption ml-2" />
                </v-col>
                <v-col cols="8">
                    <v-autocomplete
                    dense outlined
                    :readonly="preview"
                    :disabled="started"
                    :items="primaries"
                    v-model="measures.selected_primary"
                    item-text="name"
                    return-object
                    autocomplete
                    ></v-autocomplete>
                </v-col>
            </v-row>   
            <v-row no-gutters>
                <v-col cols="4">
                    <div>{{ headers.nom }}</div>
                    <div class="caption ml-2" />
                </v-col>
                <v-col cols="8">
                    <NumericField 
                    dense outlined
                    solo hide-details
                    :readonly="preview"
                    :disabled="started"
                    v-model="measures.nom"
                    :precision="currentPrecision"
                    :suffix="instrument.uom"
                    :negative="false"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="4">
                    <div>{{ headers.mass }}</div>
                    <div class="caption ml-2" />
                </v-col>
                <v-col cols="8">
                    <NumericField 
                    dense outlined
                    solo hide-details
                    :readonly="preview"
                    :disabled="started"
                    v-model="measures.mass"
                    :negative="false"
                    :suffix="instrument.uom"
                    @blur="calculateNetVal"
                    :class="handleMass(measures.mass)"
                    :precision="compPrimaryPrecision"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="4">
                    <div>Valore di tara</div>
                    <div class="caption ml-2" />
                </v-col>
                <v-col cols="8">
                    <NumericField 
                    dense outlined
                    solo hide-details
                    :readonly="preview"
                    :disabled="started"
                    v-model="measures.tare"
                    :negative="false"
                    :class="handleTare(measures.tare)"
                    :precision="compPrimaryPrecision"
                    @blur="calculateNetVal"
                    :suffix="instrument.uom"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="4">
                    <div>Valore netto</div>
                    <div class="caption ml-2" />
                </v-col>
                <v-col cols="8">
                    <NumericField 
                    dense outlined
                    solo hide-details
                    disabled
                    v-model="measures.netVal"
                    :suffix="instrument.uom"
                    :key="measures.netVal"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="4">
                    <div>{{ headers.speed }}</div>
                    <div class="caption ml-2" />
                </v-col>
                <v-col cols="8">
                    <NumericField 
                    dense outlined
                    hide-details
                    disabled
                    v-model="measures.speed"
                    :negative="false"
                    />
                </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col cols="4">
                    <div>{{ headers.num }}</div>
                    <div class="caption ml-2"></div>
                </v-col>
                <v-col cols="8">
                    <v-text-field dense outlined
                    hide-details
                    class="right-input"
                    disabled
                    v-model="measures.num"
                    placeholder="0"
                    />
                </v-col>
            </v-row>
        </div>
        <div class="d-flex flex-grow-1 flex-shrink-0 justify-end my-2" v-if="!preview">
            <v-btn color="primary" @click="changeMassX(measures.netVal)" v-if="!started" :disabled="noPrimarySelected">Inizia prova</v-btn>
            <v-btn color="primary" v-else @click="started = false">Cambia misure</v-btn>
        </div>
        <div class="d-flex flex-column" v-if="started">
            <v-simple-table class="measure_table" :key="measures.nom">
                <template v-slot:default>
                <thead class="expansion">
                <tr>
                    <th class="table-text-blocks">{{headers.n}}</th>
                    <th class="table-text-blocks text-right">{{headers.reading}} <i>{{instrument.uom}}</i></th>
                    <th class="table-text-blocks text-center">{{headers.error}} <i>{{instrument.uom}}</i></th>
                </tr>
                </thead>
                <tr v-for="(item,index) of measures.items" :key="measures.nom+'_'+index">
                    <td class="table-text-blocks">{{item.n}}</td>
                    <td class="table-blocks text-right">
                        <div class="d-flex">
                        <v-btn fab small @click="changeDiv(item, 'sub')" :disabled="preview"><v-icon>remove</v-icon></v-btn>
                        <NumericField 
                        dense outlined
                        solo hide-details
                        :readonly="preview"
                        v-model="item.reading"
                        :key="measures.nom+'_'+item.n"
                        :precision="currentPrecision"
                        @blur="calculateError(item)"
                        :class="readingWarning(item.reading)"
                        :negative="false"
                        />

                        <v-btn fab small @click="changeDiv(item, 'add')" :disabled="preview"><v-icon>add</v-icon></v-btn>
                        </div>
                    </td>
                    <td class="table-blocks text-right">
                        {{item.error | formatNumber}}
                    </td>
                </tr>
            </template>               
            </v-simple-table>
        </div>
        <!-- <div class="d-flex flex-column my-2">
            <rowcomponent
            :label="headers.mean_error"
            :value="measures.mean_error | formatNumber"
            ></rowcomponent>
            <rowcomponent
            :label="headers.mpe"
            :value="measures.mpe | formatNumber"
            ></rowcomponent>
            <rowcomponent v-if="!isPretest"
            :label="headers.stdev"
            :value="measures.stdev | formatNumber"
            ></rowcomponent>
            <rowcomponent v-if="!isPretest"
            :label="headers.stdev_allowed"
            :value="measures.stdev_allowed | formatNumber"
            ></rowcomponent>
            <StatusIcon :status="measuresResult" :tooltip_text="row_tooltip[measuresResult]"/>
        </div> -->
        <div class="flex-column my-2">
            <v-row no-gutters>
                <v-col cols="3" class="d-flex body-1 font-italic">
                    <div>{{headers.mean_error}}</div>
                </v-col>
                <v-col cols="1" class="d-flex font-weight-bold">
                    <div>{{measures.mean_error}}</div>
                </v-col>
                <v-col cols="3" class="d-flex body-1 font-italic">
                    <div>{{headers.mpe}}</div>
                </v-col>
                <v-col cols="1" class="d-flex font-weight-bold">
                    <div>{{measures.mpe}}</div>
                </v-col>
                <v-col cols="1">
                    <StatusIcon :status="mean_result" :tooltip_text="row_tooltip[mean_result]"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="3" class="d-flex body-1 font-italic">
                    <div>{{headers.stdev}}</div>
                </v-col>
                <v-col cols="1" class="d-flex font-weight-bold">
                    <div>{{measures.stdev}}</div>
                </v-col>
                <v-col cols="3" class="d-flex body-1 font-italic">
                    <div>{{headers.stdev_allowed}}</div>
                </v-col>
                <v-col cols="1" class="d-flex font-weight-bold">
                    <div>{{measures.stdev_allowed}}</div>
                </v-col>
                <v-col cols="1">
                    <StatusIcon :status="stdev_result" :tooltip_text="row_tooltip[stdev_result]"/>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
// import rowcomponent from "./RowComponent"
import StatusIcon from "./StatusIcon"
import {AwiTable} from "../../utils/awiTable"
// import Big from "big.js"
export default {
    components: {StatusIcon},
    mixins: [AwiTable],
    props: ['stdevIntervals'],
    data() {
        return {
            measures: {
                mass: null,
                items: [],
                mpe: null,
                stdev: null,
                stdev_allowed: null,
                mean_error: null,
                num: 0,
                result: false,
                selected_primary: null
            },
            precision: 0,
        }
    },
   
    methods: {
        calculateStatus(){
            this.measures.mean_error = this.calculate_mean_error()
            this.measures.stdev = this.calculate_dev_std()
            this.measures.result = this.calculateResultWithStdev()
        },
    }
}
</script>